export const TOGGLE_IN_LIBRARY_BEHAVIOURS = {
  ASK: 1,
  DO_NOT_ASK: 2
};
